/**
 * No operation function
 * @returns void
 */
export const NOOP = (): void => {};

/**
 * No operation promise
 * @returns Promise<void>
 */
export const NOOP_PROMISE = (): Promise<void> => Promise.resolve();
